import React from "react";

// Components
import { UploadOutlined } from "@ant-design/icons";
import { Upload, Input, Button } from "antd";

// Helpers
import { isEmpty } from "lodash-es";

interface UploadLogoProps {
  imageFile: File | null;
  setImageFile: (file: File | null) => void;
  setLogoImageUpdated?: (updated: boolean) => void;
  uploadLogoLink?: string;
  setUploadLogoLink?: (link: string) => void;
  headerText?: string | React.ReactElement;
  disabled?: boolean;
  removeButton?: boolean;
  allowURLUpload?: boolean;
}

const UploadLogo: React.FC<UploadLogoProps> = ({
  imageFile,
  setImageFile,
  setUploadLogoLink,
  setLogoImageUpdated,
  uploadLogoLink,
  headerText,
  disabled,
  removeButton,
  allowURLUpload,
}) => {
  const hasExistingImage = !isEmpty(uploadLogoLink);
  const hasUploadedImage = !!imageFile;

  const renderAddButton = () => {
    return (
      <div className="photo-add-button">
        <UploadOutlined className="upload-icon" />
        <div className="description">Upload Image</div>
      </div>
    );
  };

  const renderImage = () => {
    const link = URL.createObjectURL(imageFile as Blob);
    return (
      <div className="image-wrapper">
        <img src={link} alt="uploaded" />
      </div>
    );
  };

  const renderExistingImage = () => {
    if (!uploadLogoLink) return null;
    return (
      <div className="image-wrapper">
        <img src={uploadLogoLink} alt="" />
      </div>
    );
  };

  const renderRemoveButton = () => {
    const clearOrganizationLogo = () => {
      if (setUploadLogoLink) setUploadLogoLink("");
      setImageFile(null);
    };

    return (
      <Button disabled={disabled} className="remove-button" onClick={clearOrganizationLogo}>
        Remove Photo
      </Button>
    );
  };

  const renderUploadContent = () => {
    if (hasUploadedImage) return renderImage();
    if (hasExistingImage) return renderExistingImage();
    return hasUploadedImage ? renderImage() : renderAddButton();
  };

  return (
    <div className={`upload-logo${disabled ? " disabled" : ""}`}>
      {headerText ? (
        <h3 className="header">
          {headerText}
          {(imageFile || uploadLogoLink) && renderRemoveButton()}
        </h3>
      ) : null}
      <Upload
        disabled={disabled}
        className={`upload-zone${hasExistingImage || hasUploadedImage ? " no-border" : ""}`}
        customRequest={() => null}
        showUploadList={false}
        action={(file) => {
          setImageFile(file);
          if (setLogoImageUpdated) setLogoImageUpdated(true);
          return "";
        }}
      >
        {renderUploadContent()}
      </Upload>

      {removeButton ? <div className="remove-button-wrapper">{renderRemoveButton()}</div> : null}

      {setUploadLogoLink && allowURLUpload ? (
        <>
          <label className="input-label">Or insert image link here</label>
          <Input
            onChange={(e) => {
              setUploadLogoLink(e.target.value);
              if (setLogoImageUpdated) setLogoImageUpdated(true);
            }}
            value={uploadLogoLink}
            disabled={!!imageFile || disabled}
          />
        </>
      ) : null}
    </div>
  );
};

export default UploadLogo;
